import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 69px;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-start;
`;

export const Subtitle = styled.p`
  color: ${(props) => props.theme.colors.davysGrey};
  align-items: flex-end;
  margin-top: 10px;
  padding: 0;
`;
